<template>
    <div>
        <div class="filterbox">
            <div class="filtertxt">
                <div style="width:100%;margin-bottom:32px;">
                    <span style='margin-right:50px;' class="labeltxt"> 手机号</span>
                    <Input v-model="fileterObj.user_name" placeholder="" style="max-width:19%;" @on-keyup.enter="filter"/>
                    <span style='margin-right:50px;margin-left:45px;' class="labeltxt">微信号</span>
                    <Input v-model="fileterObj.wechat_id" placeholder="" style="max-width:19%;" @on-keyup.enter="filter" />
                    <span style='margin-right:35px;margin-left:30px;' class="labeltxt"> 姓名</span>
                    <Input v-model="fileterObj.realname" placeholder="" style="max-width:19%;" @on-keyup.enter="filter" />
                </div>
                <div style="width:100%;">
                    <span style='margin-right:8px;' class="labeltxt"> 关注的房源数</span>
                    <div class="inputDiv">
                        <Input v-model="fileterObj.gznum_s" placeholder="" style="max-width:33%;margin-right:7px;" @on-keyup.enter="filter" />
                        <p style="display:inline-block;">至</p>
                        <Input v-model="fileterObj.gznum_e" placeholder="" style="max-width:33%;margin-right:9px;margin-left:7px;" @on-keyup.enter="filter" />
                        <p style="display:inline-block;">套</p>
                    </div>
                    
                    <span style='margin-right:8px;margin-left:41px;' class="labeltxt"> 想看的房源数</span>
                    <div class="inputDiv">
                        <Input v-model="fileterObj.xknum_s" placeholder="" style="max-width:33%;margin-right:7px;" @on-keyup.enter="filter" />
                        <p style="display:inline-block;">至</p>
                        <Input v-model="fileterObj.xknum_e" placeholder="" style="max-width:33%;margin-right:9px;margin-left:7px;" @on-keyup.enter="filter" />
                        <p style="display:inline-block;">套</p>
                    </div>
                    <span style='margin-right:8px;margin-left:30px;' class="labeltxt"> 注册日期</span>
                    <DatePicker type="daterange" split-panels placeholder="请输入日期范围" style="width:19%;" @on-change="timechange"></DatePicker>
                </div>
            </div>
            <div class="filterbtn">
                <button @click="filter">
                    查询
                </button>
            </div>
        </div>
        <div style="height:31px;background:#eff0f8;">
        </div>
        <div class="listbox company_manage">
            <div class="typeclass">
                <span :class="fileterObj.user_status==1?'active':''" @click="typeclick(1)">正常用户</span><span :class="fileterObj.user_status==2?'active':''" @click="typeclick(2)">黑名单用户</span>
            </div>
            <div :style="data1.length==0?'':'min-height:calc(100vh - 580px)'">
                <Table stripe :columns="columns1" :data="data1" disabled-hover :no-data-text="''"></Table>
                </div>
                <div style="text-align: center;padding: 66px 0;" v-show="data1.length==0">
                    <p><img src="@/assets/img/nomessage.png"></p>
                    <h1 style="font-size: 16px;padding: 10px 0;color:#101d37">未查询到相关数据</h1>
                </div>
            <div  style="margin-top:20px;">
                <div slot style="display: inline-block;line-height: 30px;color:#9f9f9f">
                        共 {{total}} 条记录  第 {{fileterObj.pageNo}}/{{allpage}} 页         
                </div>
                <Page ref="pages" :total="total" show-elevator :page-size="fileterObj.pageSize"  @on-change="pagechange">
                
                </Page>
            </div>
                
        </div>
    </div>
</template>
<script>
import { admin } from '@/api/admin'
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    data(){
        return{
            total:1,
            allpage:1,
            pageNo:1,
            type:1,
            fileterObj:{
                user_status:'1',
                pageNo:1,
                pageSize:10,
            },
            columns1: [
                    {
                        title: ' ',
                        align:'center',
                        width:60,
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            
                                        }
                                    }
                                }, params.index+1)
                            ]    
                        } 
                    },
                    {
                        title: '手机号',
                        align:'center',
                        key: 'userName',
                        render: (h, params) => {
                            return h('div',  {
                                    props: {
                                        type: 'text'
                                    }
                                }, params.row.userName?params.row.userName:'--')
                        }
                    },
                    {
                        title: '微信号',
                        align:'center',
                        key: 'wechat_id',
                        render: (h, params) => {
                            return h('div',  {
                                    props: {
                                        type: 'text'
                                    }
                                }, params.row.wechat_id?params.row.wechat_id:'--')
                        }
                    },
                    {
                        title: '姓名',
                        align:'center',
                        key: 'realname'
                    },
                    {
                        title: '关注的房源数',
                        align:'center',
                        key: 'gznum',
                        render: (h, params) => {
                            return h('div',  {
                                    props: {
                                        type: 'text'
                                    }
                                }, params.row.gznum==null?'--':params.row.gznum)
                        }
                    },
                    {
                        title: '想看的房源数',
                        align:'center',
                        key: 'xknum',
                        render: (h, params) => {
                            return h('div',  {
                                    props: {
                                        type: 'text'
                                    }
                                }, params.row.xknum==null?'--':params.row.xknum)
                        }
                    },
                    {
                        title: '注册日期',
                        align:'center',
                        key: 'createDate',
                        render: (h, params) => {
                            return h('div',  {
                                    props: {
                                        type: 'text'
                                    }
                                }, params.row.createDate?params.row.createDate.split(' ')[0]:'--')
                        }
                    },
                    {
                        title: '操作',
                        key: 'sale',
                        width:'200',
                        align:'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        color: '#3569fd',
                                        fontSize:'14px',
                                    },
                                    on: {
                                        click: () => {
                                            if(this.fileterObj.user_status==1){
                                                this.frozen(params.row.userId,params.row.userName,2);
                                            }else{
                                                this.frozen(params.row.userId,params.row.userName,1);
                                            }
                                            
                                        }
                                    }
                                }, this.fileterObj.user_status==1?'加入黑名单':'从黑名单移除')
                            ])
                        }
                    }            
                ],
                data1: []
            
        }
    },
    mounted(){
        this.getlist();
    },
    methods:{
        getlist(){
            admin.getCuserList(this.fileterObj).then(res=>{
                if(res.data.success==true){
                    this.data1=res.data.result.records;
                    this.total=res.data.result.total;
                    this.allpage=res.data.result.pages?res.data.result.pages:1
                }
            })
        },
        filter(){
            this.fileterObj.pageNo=1;
            this.$refs['pages'].currentPage = 1;
            this.getlist();
        },
        typeclick(n){
            // if(n==1){
                
                this.fileterObj.user_status!=n?this.fileterObj.user_status=n:'';
                this.pagechange(1);
                // this.getlist();
            // }
        },
        timechange(val){
            this.fileterObj.reg_time_s=val[0];
            this.fileterObj.reg_time_e=val[1];
            this.filter();
        },
        pagechange(n){
            this.fileterObj.pageNo=n;
            this.getlist();
        },
        frozen(userId,userName,userStatus){
            admin.userFrozen(userId,userName,userStatus,'1111').then(res=>{
                if(res.data.success==true){
                    this.$Message.success(res.data.message);
                    this.getlist();
                }
            })
        }
    }
}
</script>

<style scoped>
    .filterbox{
        height: 184px;
        box-sizing: border-box;
        padding: 40px 60px 40px 40px;
        background-color: #ffffff;
        box-shadow: 0px 0px 21px 0px 
            rgba(191, 199, 221, 0.26);
        border-radius: 4px;
    }
    .filtertxt{
        width:100%;
        display: inline-block;
        vertical-align: middle;
    }
    .labeltxt{
        color: #101d37;
        font-size: 14px;
    }
    .filterbtn{
        width:100%;
        display: inline-block;
        text-align: left;
        padding-right: 60px;
        vertical-align: middle;
        margin-top:15px;
    }
    .filterbtn button{
        border: none;
        color: #ffffff;
        width: 132px;
        height: 42px;
        background-color: #26ce95;
        box-shadow: 0px 4px 6px 0px 
            rgba(38, 206, 149, 0.22);
        border-radius: 3px;
        line-height: 42px;
        
    }
    .listbox{
       padding: 20px 23px 33px 30px;
    }
    .typeclass{
        margin-bottom:10px;
    }
    .typeclass span{
        margin-right: 20px;
        cursor: pointer;
    }
    span.active{
        color: #3569fd;
    }
    .creatbtn{
        width: 132px;
        height: 42px;
        background-color: #f7f9fc;
        border-radius: 4px;
        color: #3569fd;
        font-size: 16px;
        border: none;
        margin-bottom: 20px;
    }
    .inputDiv{
        width: 19%;
        display: inline-block;
    }
</style>


